module.exports = __webpack_public_path__ + "static/img/05.5f003408.png";